import { useEffect } from "react";
import { INextTerm } from "../../../../../models/dashboard/studentDashboard";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { connect, useDispatch } from "react-redux";
import { setAppsForTerm } from "../../../../../store/slices/master/appSlice";
import { getApps } from "../../../../../action/masters/appActionCreator";
import { IApps } from "../../../../../models/master/apps";
import { getDescriptionText } from "../../../../../action/common/commonActionCreator";
import { setDescriptionText } from "../../../../../store/slices/common/commonSlice";
import { baseURL } from "../../../../../constants/commonConstants";

const PlanYourNextTerm = (props: INextTerm) => {
  const { getAllApps, appsForTerm, getDescriptionText, description } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getAllApps(pageBlockId.planNextTerm, undefined);
    getDescriptionText(pageBlockId.planNextTerm);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setAppsForTerm([]));
      dispatch(setDescriptionText([]));
    };
  }, []);
  return (
    <div className="widgets">
      <div className="title">
        <h2>All Plan Your Next Term</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {appsForTerm?.map((app: IApps) => (
            <div className="col-md-12 mb-3" key={app.id}>
              <div className="resourcecard icon-visibility">
                <a href={app.url} target="_blank" className="h-100">
                  <div className="img">
                    <img src={baseURL + app.image} alt={app.name} />
                  </div>
                  <div className="dtls">
                    <h3 className="para-hide-1">{app.name}</h3>
                    <p className="para-hide-2">{app.description}</p>
                  </div>
                  <span>
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getAllApps: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
};

function mapStateToProps(state: any) {
  return {
    appsForTerm: state.app.appsForTerm,
    description: state.common.description,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanYourNextTerm);
